"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts = require("../constants");
var toOnajiKaAto_1 = require("./toOnajiKaAto");
var yoriMae_1 = require("./yoriMae");
var futureGengo = { start: [99999, 11, 31] };
function findGengo(date) {
    var gengo = consts.date.gengo.find(function (_a, index) {
        var start = _a.start;
        var nextStart = (consts.date.gengo[index - 1] || futureGengo).start;
        var startDate = new Date(start[0], start[1], start[2]);
        var nextStartDate = new Date(nextStart[0], nextStart[1], nextStart[2]);
        return toOnajiKaAto_1.default(date, startDate) && yoriMae_1.default(date, nextStartDate);
    });
    if (!gengo) {
        var year = date.getFullYear();
        throw new Error("\u897F\u66A6" + year + "\u5E74\u306B\u5BFE\u5FDC\u3059\u308B\u5143\u53F7\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002");
    }
    return gengo;
}
exports.default = findGengo;
